/**
 * Rate For Dropdown Handler
 * Handles switching between dropdown and custom input for the Rate For field
 */

const rateForSelect = document.getElementById('rate_for_select');
const rateForCustom = document.getElementById('rate_for_custom');
const rateForHidden = document.getElementById('rate_for_hidden');

// Map of select values to display names
const rateForMap = {
    'truck_trailer': 'Truck & Trailer',
    'tandem': 'Tandem',
    'street_sweeper': 'Street Sweeper',
    'semi_tipper': 'Semi Tipper',
    'water_cart': 'Water Cart',
    'dozer': 'Dozer',
    'NDD': 'NDD',
    'other': 'other'
};

// Initialize on page load
function initRateForDropdown() {
    if (!rateForSelect || !rateForCustom || !rateForHidden) {
        return;
    }

    // Check if custom value is set on page load
    const currentValue = rateForHidden.value;
    const isCustomValue = currentValue && !Object.values(rateForMap).includes(currentValue) && currentValue !== '';

    if (isCustomValue) {
        rateForSelect.value = 'other';
        rateForCustom.style.display = 'block';
        rateForCustom.value = currentValue;
        rateForCustom.disabled = false;
    }

    // Handle select change
    rateForSelect.addEventListener('change', function() {
        const selectedValue = this.value;

        if (selectedValue === 'other') {
            // Show custom input
            rateForCustom.style.display = 'block';
            rateForCustom.disabled = false;
            rateForCustom.focus();

            // Update hidden field when custom input changes
            rateForCustom.addEventListener('input', function() {
                rateForHidden.value = this.value;
            });
        } else {
            // Hide custom input and use dropdown value
            rateForCustom.style.display = 'none';
            rateForCustom.disabled = true;
            rateForCustom.value = '';

            // Update hidden field with display name from map
            rateForHidden.value = selectedValue === '' ? '' : rateForMap[selectedValue];
        }
    });

    // Ensure hidden field is updated when custom input changes
    rateForCustom.addEventListener('input', function() {
        if (rateForSelect.value === 'other') {
            rateForHidden.value = this.value;
        }
    });
}

// Run on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRateForDropdown);
} else {
    initRateForDropdown();
}